module.exports = __webpack_public_path__ + "a5d9de9db2a3b5ce661cf5822af601bb.png";